import React, { useState, useEffect } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import SelectBoxFilter from '../common/select-box-filter'
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import { useDataProvider } from 'react-admin';

const useStyles = makeStyles(theme => ({
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
}))

function Weather() {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const classes = useStyles();
    const dataProvider = useDataProvider();

    const [locations, setLocations] = useState([]);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { location } = nodeSelected.applicationData.nodeApplication.weatherLocation;

    const getListLocation = () => {
        dataProvider('GET_LIST', 'location', {
            filter: {},
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            setLocations(data);
            if (!location && data.length > 0) {
                onChangeData(data[0].city);
            }
        }).catch(error => console.error('@@@ getListLocation error:', error));
    }

    const onChangeData = (value) => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                weatherLocation: {
                    location: value
                }
            }
        };

        dispatch(changeNodeGlobalData(newNode));
    }

    useEffect(() => {
        getListLocation();
    }, []);


    return (
        <Box mt={3.5} style={{ width: 500, marginTop: 20 }}>
            <SelectBoxFilter
                disabled={!isEditing}
                data={locations}
                label={translate('resources.infoPage.weather')}
                value={location}
                onChange={(value) => onChangeData(value.city)}
                keyName='city'
                placeholder={translate('resources.infoPage.filter_location')}
            />
        </Box>
    )
}

export default Weather;
